module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"test":"test","passed":"passed","notPassed":"not passed","explanation":"Explanation","cutoff":"Сutoff","noAnswer":"There is no answer","timeSpent":"Time elapsed","correctAnswer":"correct answer","pointsScored":"Points earned","outOf":"out of","passing":"Passing"}}')
  delete Component.options._Ctor
}
